
import './App.css';
import AcademicPortfolio from './Components/AcademicPortfolio/AcademicPortfolio';
import Contact from './Components/Contact/Contact';
import Education from './Components/Education/Education';
import Experience from './Components/Experience/Experience';
import Footer from './Components/Footer/Footer';
import Header from './Components/Header/Header';
import Hero from './Components/Hero/Hero';
import Research from './Components/Research/Research';

function App() {
  return (
    <>
    <Header/>
    <Hero/>
    <Education/>
    <Experience/>
    <AcademicPortfolio/>
    <Research/>
    <Contact/>
    <Footer/>
    </>
  );
}

export default App;
